import Vue from 'vue';
import _ from 'lodash';
import {
    GET_ROLE_LIST_REQUEST,
    GET_ROLE_LIST_SUCCESS,
    GET_ROLE_LIST_FAILURE,
    UPDATE_ROLE_LIST_PARAMS,
    RESET_ROLE_LIST_DATA
} from '../mutationTypes';

const state = {
    loading: false,
    list: [],
    page: 1,
    pageSize: 20,
    pageCount: 0,
    totalCount: 0,
};

const mutations = {
    [GET_ROLE_LIST_REQUEST](state) {
        state.loading = true;
    },
    [GET_ROLE_LIST_SUCCESS](state, res) {
        state.loading = false;
        const { data, page_count: pageCount, count } = res;

        state.list = data;
        state.pageCount = Number(pageCount);
        state.totalCount = count;
    },
    [GET_ROLE_LIST_FAILURE](state) {
        state.loading = false;
    },
    [UPDATE_ROLE_LIST_PARAMS](state, params) {
        const { page, type, index } = params;

        if (page) state.page = page;

        if (type === 'del' && index >= 0) {
            state.list.splice(index, 1);
        }
    },
    [RESET_ROLE_LIST_DATA](state) {
        _.extend(state, _.cloneDeep({
            loading: false,
            list: [],
            page: 1,
            pageSize: 20,
            pageCount: 0,
            totalCount: 0,
        }));
    }
};

export const actions = {
    async getRoleList({ commit }) {
        commit(GET_ROLE_LIST_REQUEST);

        const res = await Vue.$ajax.get('roleList', {
            page: state.page,
            page_size: state.pageSize
        });

        if (!res.errorType) {
            commit(GET_ROLE_LIST_SUCCESS, res);
        } else {
            commit(GET_ROLE_LIST_FAILURE);
        }
    },
    resetRoleList({ commit }) {
        commit(RESET_ROLE_LIST_DATA);
    }
};

export default {
    state,
    mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/roleList.js